"use client"

import React, { useMemo } from "react"
import { useUbStorefrontState } from "@/store/ubStorefrontState"

import { ExtendedAddressRO } from "@/lib/storefront/addresses/address"
import { CheckoutContext } from "@/lib/storefront/checkout/checkout-service"
import { AddressFields } from "@/components/common/addresses/AddressFields"
import BasicCard from "@/components/common/BasicCard"
import { UbCheckoutReviewShipToAddressesStoryblok } from "@/components/storyblok/component-types"

interface CheckoutAddressesShipToClientProps {
  blok: UbCheckoutReviewShipToAddressesStoryblok
  checkoutContext: CheckoutContext
}

export default function CheckoutAddressesShipToClient(props: CheckoutAddressesShipToClientProps) {
  const { basketData } = useUbStorefrontState()

  const shipToAddress: ExtendedAddressRO = useMemo(() => {
    const commonShipToAddressLink = basketData?.data?.commonShipToAddress
    if (commonShipToAddressLink) {
      return basketData?.included?.commonShipToAddress
        ? basketData?.included?.commonShipToAddress[commonShipToAddressLink]
        : undefined
    }
  }, [basketData])

  return (
    <div className={"flex w-full flex-col gap-12"}>
      <BasicCard className={"top-[7.5rem] min-h-0 border-none p-0 sm:p-0 lg:top-[8.5rem]"}>
        <div className={"flex w-full flex-col justify-between gap-12 sm:flex-row"}>
          <div className={"flex w-full flex-row justify-between gap-2"}>
            <AddressFields address={shipToAddress} isB2B={props.checkoutContext.isB2B} />
          </div>
        </div>
      </BasicCard>
    </div>
  )
}
